
import { css } from 'lit';
export default css`
.takeover-modal {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 20;
  height: 0px;
  width: 100vw;
  overflow: hidden;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}@media (min-width: 768px) {.takeover-modal {
    display: none;
  }
}.takeover-modal--open {
  position: fixed;
}.takeover-modal--open {
  height: 100vh;
}.takeover-modal--open {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}.takeover-modal--force-top {
  z-index: 9999;
}.takeover-modal--white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}.takeover-modal--white {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}.takeover-modal--filters {
  z-index: 50;
}.takeover-modal--filters.takeover-modal--open {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}.takeover-modal--filters .takeover-modal__close-button {
  margin-right: 1rem;
}.takeover-modal--filters .takeover-modal__close-button {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}.takeover-modal--filters .takeover-modal__close-button {
      margin-top: 1.25rem;
      width: 18px;
    }@media (min-width: 1024px) {.takeover-modal--show-on-large {
    position: static;
  }
}@media (min-width: 1024px) {.takeover-modal--show-on-large {
    height: auto;
  }
}@media (min-width: 1024px) {.takeover-modal--show-on-large {
    width: auto;
  }
}@media (min-width: 1024px) {.takeover-modal--show-on-large {
    overflow: visible;
  }
}.takeover-modal__trigger:focus {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}.takeover-modal__trigger:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}@media (min-width: 1024px) {.takeover-modal__trigger--hide-on-large {
    display: none;
  }
}.takeover-modal__content {
  position: absolute;
}.takeover-modal__content {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}.takeover-modal__content {
  display: block;
}.takeover-modal__content {
  height: 100%;
}.takeover-modal__content {
  width: 100%;
}@media (min-width: 1024px) {.takeover-modal__content--show-on-large {
    position: static;
  }
}@media (min-width: 1024px) {.takeover-modal__content--show-on-large {
    height: auto;
  }
}@media (min-width: 1024px) {.takeover-modal__content--show-on-large {
    width: auto;
  }
}@media (min-width: 1024px) {.takeover-modal__content--show-on-large {
    overflow: visible;
  }
}.takeover-modal__content--filters {
  display: block;
}.takeover-modal__content--filters {
      margin-top: 3.5rem;
      padding: 0 17px;
    }.takeover-modal__close-button {
  position: absolute;
}.takeover-modal__close-button {
  top: 0px;
}.takeover-modal__close-button {
  right: 0px;
}.takeover-modal__close-button {
  z-index: 30;
}.takeover-modal__close-button {
  margin-right: 1.25rem;
}.takeover-modal__close-button {
  margin-top: 1.25rem;
}.takeover-modal__close-button {
  display: block;
}.takeover-modal__close-button {
  height: 1.5rem;
}.takeover-modal__close-button {
  width: 1.5rem;
}.takeover-modal__close-button:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}.takeover-modal__close-button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}@media (min-width: 1024px) {.takeover-modal__close-button--hide-on-large {
    display: none;
  }
}.takeover-modal__close-button--arrow {
  position: relative;
}.takeover-modal__close-button--arrow {
  margin-left: 2rem;
}.takeover-modal__close-button--arrow {
  margin-top: 1.5rem;
}.takeover-modal__close-button--arrow {
  height: auto;
}.takeover-modal__close-button--arrow {
  fill: currentColor;
}.takeover-modal__close-button--arrow {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
`;